<template>
    <div v-if="msgAlerta" class="info-alert row-space clickable" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>

    <div class="form-edit-page">
        <div class="row">
            <SimSelect class="form-item" v-model:idSelecionado="idSim" />
            <div class="form-item-data">
                <label class="label-caption" >Data Coleta</label>
                <input type="date" v-model="edDtDoc" />
            </div>
            <button class="btn-small" :disabled="isLoadingDados" @click="lerDados">Localizar</button>
            <button class="btn-small" @click="closeForm">Retornar</button>
        </div>
    </div>


    <div v-if="lsDados.length>0" class="form-edit-page mt-sm">
        <div class="row">
            <div class="form-item">
                <label class="label-caption">Coleta</label>
                <select v-model="idSelecionado">
                    <option v-for="item in lsDados" :key="item.id" :value="item.id">
                        {{ item.id }} - {{ item.nmestabelecimento }}
                    </option>
                </select>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center field-label--destaque">{{ objSelecionado?.xsequencia }}</div>
            </div>
            
            <div class="form-item-char10">
                <label class="label-caption">Data</label>
                <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objSelecionado?.amostra_dtcolheita) }}</div>
            </div>
            
            <div class="form-item-char05">
                <label class="label-caption">Hora</label>
                <div class="field-label field-label-center">{{ Funcoes.formatTimeFromJson(objSelecionado?.amostra_hrcolheita) }}</div>
            </div>

            <div class="form-item-char40">
                <label class="label-caption">Categoria</label>
                <div class="field-label">{{ objSelecionado?.xamostra_categoria }}</div>
            </div>
        </div>

        
        <div class="row mt-linha">
            <div class="form-item">
                <label class="label-caption">Nome Oficial</label>
                <div class="field-label">{{ objSelecionado?.amostra_nmoficial }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Local da Coleta</label>
                <div class="field-label">{{ objSelecionado?.amostra_local_colheita }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Quantidade</label>
                <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objSelecionado?.amostra_qtd) }}</div>
            </div>
        </div>


        <div class="row mt-linha">
            <div class="form-item">
                <label class="label-caption">Nome Coletor</label>
                <div class="field-label">{{ objSelecionado?.nmcoletor }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Nome Responsável Presente</label>
                <div class="field-label">{{ objSelecionado?.nmresponsavel }}</div>
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption">Vínculo do Responsável</label>
                <div class="field-label">{{ objSelecionado?.xtpresponsavel }}</div>
            </div>
        </div>



        <div class="row mt-linha">
            <div class="form-item">
                <label class="label-caption">Justificativa do Cancelamento</label>
                <textarea v-model="edJustificativa" maxlength="2000" rows="5" />
            </div>
        </div>


        <div class="row-end mt-sm">
            <button class="btn-small btn-delete" :disabled="isSaving" @click="salvarCancelamento">CANCELAR</button>
        </div>
    </div>

    <div v-else-if="ckPesquisado">
        <EmptyStateComponent 
            :title="'PESQUISA DE COLETAS'"
            :message="'Nenhuma coleta selecionada. Favor revisar os filtros utilizados'"
        />
    </div>
    
    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="lerDados" 
        @confirmed="lerDados" />

    <SenhaModal ref="senhaModalRef" />
</template>


<script setup>
import { computed, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);

const ckPesquisado = ref(false);
const edDtDoc = ref(null);
const edJustificativa = ref(null);
const idSelecionado = ref(null);
const idSim = ref(null);
const isLoadingDados = ref(false);
const isSaving = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const objAssinatura = ref(criarAssinatura());
const senhaModalRef = ref(null);

const msgOkModal = ref("Protocolo cancelado com sucesso");
const showOkModal = ref(null);

const objSelecionado = computed(() => lsDados.value.find(item => item.id === idSelecionado.value));


function closeForm(){
    emit('close');
}


async function lerDados(){
    try{
        msgAlerta.value=null;
        showOkModal.value=false; // CASO TENHA CHAMADO ROTINA DO MODAL
        Funcoes.validarNumeroPositivo(idSim.value, 'Informe o S.I.M.');
        Funcoes.validarData(edDtDoc.value, {nomeCampo: 'Data Coleta'});
        isLoadingDados.value=true;

        const rPlas = await Api.genericPost('/lspla/pla01', {
            idsim: idSim.value,
            datainicial: edDtDoc.value,
            datafinal: edDtDoc.value,
        });
        lsDados.value = rPlas || [];
        if (lsDados.value.length>0) idSelecionado.value = lsDados.value[0].id;

        ckPesquisado.value = true;

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoadingDados.value = false;}
}


async function salvarCancelamento(){
    try{
        msgAlerta.value=null;
        Funcoes.validarTexto(edJustificativa.value, {nomeCampo: 'Justificativa do Cancelamento', minText: 10});
        isSaving.value=true;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        objAssinatura.value = criarAssinatura();
        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:PLA01|IDREF:${objSelecionado.value.id}|PROT:${objSelecionado.value.protocolo}|CANCELAMENTO`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objSelecionado.value.id;
        objAssinatura.value.doc_tipo = 'PLA01';
        objAssinatura.value.acao = 'pla01Cancelamento';
        objAssinatura.value.acao_id = objSelecionado.value.id;
        objAssinatura.value.acao_obs = edJustificativa.value;

        const respAss = await Api.genericPut('/cad/assinatura', objAssinatura.value);
        if (respAss.bolok === 1){
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isSaving.value = false;}
}
</script>